// Legacy WordPress 301 redirect map.
// Each entry redirects an old URL directly to its final live destination
// (no chains). Both trailing-slash and non-trailing-slash variants are
// generated automatically by App.tsx.
export const LEGACY_REDIRECTS: Array<[string, string]> = [
  // Core service pages
  ["/partial-hospitalization-addiction-treatment-php-in-new-jersey", "/php-cherry-hill-nj"],
  ["/intensive-outpatient-iop-addiction-drug-alcohol-treatment-in-new-jersey", "/iop-cherry-hill-nj"],
  ["/detox-in-new-jersey", "/detox-referral-coordination-nj"],
  ["/drug-and-alcohol-detox-center-nj", "/detox-referral-coordination-nj"],
  ["/medication-assisted-treatment-in-new-jersey", "/medication-assisted-treatment-nj"],
  ["/verify-insurance-for-detox-and-rehab-in-new-jersey", "/verify-insurance"],
  ["/suboxone-doctor", "/suboxone-doctor-cherry-hill-nj"],
  ["/sublocade-doctor-near-me", "/sublocade-doctor-nj"],
  ["/virtual-iop", "/virtual-iop-new-jersey"],
  ["/telehealth-addiction-treatment", "/virtual-iop-new-jersey"],
  ["/telehealth", "/virtual-iop-new-jersey"],
  ["/psychiatric-evaluations-in-new-jersey", "/psychiatric-evaluation-nj"],
  ["/drug-alcohol-evaluations-new-jersey", "/drug-alcohol-evaluation-nj"],
  ["/outpatient-detox", "/detox-referral-coordination-nj"],
  ["/outpatient-rehab-new-jersey", "/iop-cherry-hill-nj"],

  // Conditions
  ["/heroin-addiction-rehab", "/heroin-opioid-addiction-treatment-nj"],
  ["/opioid-addiction-treatment", "/heroin-opioid-addiction-treatment-nj"],
  ["/alcohol-withdrawal", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/alcohol-addiction-rehab", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/fentanyl-addiction", "/fentanyl-addiction-treatment-nj"],
  ["/benzodiazepine-withdrawal", "/benzodiazepine-addiction-treatment-nj"],
  ["/cocaine-addiction", "/cocaine-addiction-treatment-nj"],
  ["/marijuana-addiction", "/marijuana-addiction-treatment-nj"],
  ["/adderall-addiction", "/adderall-addiction-treatment-nj"],
  ["/painkiller-addiction", "/painkiller-addiction-treatment-nj"],
  ["/methadone-detox", "/methadone-addiction-treatment-nj"],

  // General pages
  ["/new-jersey-drug-and-alcohol-treatment", "/addiction-treatment-guide-south-jersey-nj"],
  ["/new-jersey-addiction-treatment", "/addiction-treatment-guide-south-jersey-nj"],
  ["/drug-alcohol-rehab-new-jersey", "/addiction-treatment-guide-south-jersey-nj"],
  ["/treatment-center-for-addiction", "/addiction-treatment-guide-south-jersey-nj"],
  ["/new-jersey-addiction-treatment-center", "/addiction-resources-new-jersey"],
  ["/contact-us", "/contact"],
  ["/blue-cross-blue-shield-rehab-coverage", "/insurance/blue-cross-blue-shield-rehab-nj"],
  ["/career", "/contact"],
  ["/addiction-resources", "/addiction-resources-new-jersey"],
  ["/detox-blog", "/addiction-resources-new-jersey"],
  ["/areas-we-serve-for-detox", "/service-areas"],
  ["/hunterdon-county-new-jersey-detox", "/detox-referral-coordination-nj"],
  ["/bergen-county-new-jersey-detox", "/detox-referral-coordination-nj"],
  ["/somerset-county-new-jersey-detox", "/detox-referral-coordination-nj"],
  ["/treatments", "/"],
  ["/dual-diagnosis-treatment-centers-in-nj", "/psychiatric-evaluation-nj"],
  ["/mobile-text-message-terms-conditions-privacy-policy", "/privacy-policy"],
  ["/landing-page", "/verify-insurance"],

  // Blog posts (2024)
  ["/2024/02/19/combining-support-and-independence-iop-with-housing-options", "/iop-with-housing-options-nj"],
  ["/2024/08/30/how-iop-programs-support-addiction-recovery-without-full-hospitalization", "/how-iop-programs-support-addiction-recovery-nj"],
  ["/2024/02/18/evening-intensive-outpatient-program-balancing-daily-life", "/evening-iop-new-jersey"],
  ["/2024/02/17/exploring-the-link-can-meth-use-lead-to-cancer", "/meth-use-cancer-link-nj"],
  ["/2024/02/16/understanding-vivitrol-duration-and-effectiveness-of-the-shot", "/vivitrol-shot-duration-effectiveness-nj"],
  ["/2024/02/15/the-addictive-nature-why-is-oxycodone-so-addictive", "/oxycodone-addiction-treatment-nj"],
  ["/2024/02/14/finding-the-right-help-a-guide-to-rehab-centers-near-you", "/"],
  ["/2024/02/13/supporting-a-loved-one-what-to-say-to-someone-who-relapses", "/family-guide-new-jersey"],
  ["/2024/02/12/the-role-of-substance-abuse-interventionists-in-recovery", "/addiction-resources-new-jersey"],
  ["/2024/02/11/comparing-effects-adderall-and-xanax", "/adderall-addiction-treatment-nj"],
  ["/2024/02/10/navigating-blue-cross-blue-shield-drug-rehab-coverage", "/insurance/blue-cross-blue-shield-rehab-nj"],
  ["/2024/02/10/starting-the-journey-exploring-fentanyl-detox-centers", "/fentanyl-addiction-treatment-nj"],
  ["/2024/02/10/choosing-the-right-nj-detox-center", "/detox-referral-coordination-nj"],
  ["/2024/02/10/finding-hope-in-drug-rehab-south-jersey", "/"],
  ["/2024/02/09/alcohol-support-group-near-me", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/2024/02/09/outpatient-drug-rehab-nj-tailored-recovery-programs-in-new-jersey", "/iop-cherry-hill-nj"],
  ["/2024/02/09/seeking-help-nearby-fentanyl-rehab-centers-in-your-area", "/fentanyl-addiction-treatment-nj"],
  ["/2024/02/09/drug-rehab-aetna-benefits-strategies-for-you", "/verify-insurance"],
  ["/2024/02/08/intervention-specialists-their-crucial-role-in-addiction-treatment", "/addiction-resources-new-jersey"],
  ["/2024/02/08/is-cocaine-a-depressant-understanding-the-effects-on-the-brain", "/cocaine-addiction-treatment-nj"],
  ["/2024/02/08/navigating-cherry-hill-detox-a-comprehensive-guide", "/detox-referral-coordination-nj"],
  ["/2024/02/07/cocaine-uncovered-five-essential-facts-everyone-should-know", "/cocaine-addiction-treatment-nj"],
  ["/2024/02/07/decoding-early-morning-shakes-causes-and-meanings", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/2024/02/06/the-dangerous-mix-xanax-and-meth-co-use-explained", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/02/06/the-interactions-of-xanax-and-suboxone-what-you-need-to-know", "/medication-assisted-treatment-nj"],
  ["/2024/02/05/ketamine-and-xanax-understanding-the-risks-and-effects", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/02/04/veterans-recovery-resources-tailored-assistance-for-our-heroes", "/addiction-resources-new-jersey"],
  ["/2024/02/03/naltrexone-vomiting-side-effects-and-management", "/medication-assisted-treatment-nj"],
  ["/2024/02/02/does-wellbutrin-help-with-opioid-withdrawal-exploring-treatment-options", "/heroin-opioid-addiction-treatment-nj"],
  ["/2024/02/01/ativan-for-depression-benefits-and-risks-explored", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/02/01/xanax-vs-valium-a-detailed-comparison", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/01/31/bupropion-withdrawal-timeline-what-to-expect", "/addiction-resources-new-jersey"],
  ["/2024/01/30/klonopin-vs-valium-which-one-for-anxiety-management", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/01/29/what-does-fentanyl-smell-like-identifying-the-hidden-danger", "/fentanyl-addiction-treatment-nj"],
  ["/2024/01/28/shows-about-addiction-awareness-through-entertainment", "/addiction-resources-new-jersey"],
  ["/2024/01/27/white-dope-uncovering-the-hidden-dangers", "/heroin-opioid-addiction-treatment-nj"],
  ["/2024/01/26/xanax-vs-valium-which-is-more-effective-for-anxiety", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/01/25/choosing-the-right-philadelphia-drug-rehab-a-guide", "/"],
  ["/2024/01/24/finding-the-best-rehab-in-cherry-hill-nj-your-guide-to-recovery", "/"],
  ["/2024/01/24/is-klonopin-stronger-than-valium-comparing-effects-and-uses", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/01/24/the-truth-about-colored-cocaine-myths-and-realities", "/cocaine-addiction-treatment-nj"],
  ["/2024/01/24/what-do-heroin-needles-look-like-a-visual-guide-to-awareness", "/heroin-opioid-addiction-treatment-nj"],
  ["/2024/01/23/unraveling-the-mystery-of-pink-meth-what-you-need-to-know", "/addiction-resources-new-jersey"],
  ["/2024/01/23/clonazepam-for-alcohol-withdrawal-how-it-helps", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/01/22/should-recovering-drug-addicts-drink-alcohol-weighing-the-risks", "/addiction-resources-new-jersey"],
  ["/2024/01/22/what-is-greening-out-understanding-cannabis-overconsumption", "/marijuana-addiction-treatment-nj"],
  ["/2024/01/21/recognizing-a-meth-allergic-reaction-key-signs-and-responses", "/addiction-resources-new-jersey"],
  ["/2024/01/20/best-detox-practices-for-coke-a-healthier-approach", "/cocaine-addiction-treatment-nj"],
  ["/2024/01/20/athletes-with-drug-problems-stories-of-struggle-and-recovery", "/addiction-resources-new-jersey"],
  ["/2024/01/20/effective-ways-to-get-weed-out-of-your-system-safely", "/marijuana-addiction-treatment-nj"],
  ["/2024/01/19/signs-of-shooting-up-warning-signs-of-iv-drug-use", "/heroin-opioid-addiction-treatment-nj"],
  ["/2024/01/19/pain-medication-list-strongest-to-weakest", "/painkiller-addiction-treatment-nj"],
  ["/2024/01/18/understanding-klonopin-and-alcohol-withdrawal", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/01/17/how-to-reduce-alcohol-bloat-effective-strategies", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/2024/01/16/the-alcohol-withdrawal-timeline-what-to-expect", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/2024/01/15/death-by-xanax-understanding-the-risks-and-prevention", "/benzodiazepine-addiction-treatment-nj"],
  ["/2024/01/14/exploring-options-outpatient-rehab-in-new-jersey", "/iop-cherry-hill-nj"],
  ["/2024/01/13/does-beer-give-you-gas-debunking-myths-and-facts", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/2024/01/12/identifying-meth-hives-symptoms-and-treatment", "/addiction-resources-new-jersey"],

  // Blog posts (2023)
  ["/2023/08/16/substance-abuse-treatment", "/"],
  ["/2023/08/20/detox-programs", "/detox-referral-coordination-nj"],
  ["/2023/08/21/addiction-treatment", "/"],
  ["/2023/08/10/detox-nj", "/detox-referral-coordination-nj"],
  ["/2023/09/04/alcohol-rehab-ny", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/2023/09/18/etoh-rehab", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/2023/10/16/addiction-rehab-new-jersey", "/"],

  // Content pages
  ["/xanax-side-effects", "/benzodiazepine-addiction-treatment-nj"],
  ["/liver-failure-symptoms", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/alcohol-addiction-help-near-me", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/detox-programs", "/detox-referral-coordination-nj"],
  ["/inpatient-drug-rehab-new-jersey", "/php-cherry-hill-nj"],
  ["/what-is-outpatient-drug-rehab", "/iop-cherry-hill-nj"],
  ["/how-to-help-an-alcoholic", "/family-guide-new-jersey"],
  ["/is-gabapentin-addictive", "/addiction-resources-new-jersey"],
  ["/medical-detox-near-me", "/detox-referral-coordination-nj"],
  ["/substance-abuse-treatment-centers-near-me", "/drug-rehab-near-me-south-jersey-nj"],
  ["/uppers", "/addiction-resources-new-jersey"],
  ["/signs-of-drug-abuse", "/addiction-resources-new-jersey"],
  ["/what-are-the-12-steps-of-alcoholics-anonymous", "/addiction-resources-new-jersey"],
  ["/rehab-for-drugs-near-me", "/drug-rehab-near-me-south-jersey-nj"],
  ["/drug-rehab-near-me", "/drug-rehab-near-me-south-jersey-nj"],
  ["/how-to-detox-from-weed", "/marijuana-addiction-treatment-nj"],
  ["/how-to-stage-an-intervention", "/family-guide-new-jersey"],
  ["/sobriety-solutions", "/addiction-resources-new-jersey"],
  ["/meth-withdrawal-symptoms", "/meth-use-cancer-link-nj"],
  ["/cocaine-withdrawal-symptoms", "/cocaine-addiction-treatment-nj"],
  ["/marijuana-detox", "/marijuana-addiction-treatment-nj"],
  ["/how-long-does-it-take-to-detox-from-alcohol", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/dope-sick", "/heroin-opioid-addiction-treatment-nj"],
  ["/alcohol-rehab-near-me", "/alcohol-addiction-treatment-cherry-hill-nj"],
  ["/inpatient-vs-outpatient", "/addiction-treatment-guide-south-jersey-nj"],
  ["/aa-hotline", "/addiction-resources-new-jersey"],
  ["/first-responder-support-groups-near-me", "/addiction-resources-new-jersey"],
  ["/is-liver-damage-reversible", "/addiction-resources-new-jersey"],

  // Special
  ["/thank-you-contact", "/"],
  ["/thank-you-insurance", "/verify-insurance"],
  ["/shop", "/"],

  // Local
  ["/camden-county-addiction-treatment", "/addiction-treatment-camden-county-nj"],
  ["/addiction-treatment-camden-county", "/addiction-treatment-camden-county-nj"],
  ["/camden-nj-addiction-treatment", "/addiction-treatment-camden-nj"],



  // MAT
  ["/suboxone-doctor-near-me", "/suboxone-doctor-cherry-hill-nj"],
  ["/sublocade", "/sublocade-doctor-nj"],
  ["/vivitrol", "/vivitrol-shot-duration-effectiveness-nj"],
  ["/medication-assisted-treatment", "/medication-assisted-treatment-nj"],

  // Sober living
  ["/recovery-housing", "/recovery-housing-nj"],
  ["/sober-living-nj", "/recovery-housing-nj"],
  ["/sober-living-cherry-hill", "/recovery-housing-nj"],
];

// /index.php is special — handled as a single exact path (no trailing slash variant).
export const LEGACY_REDIRECTS_EXACT: Array<[string, string]> = [
  ["/index.php", "/"],
];
